module.exports = __webpack_public_path__ + "static/media/clue-4.b058137b.svg";